import { render } from "./SummariesScreen.vue?vue&type=template&id=513a114d&scoped=true"
import script from "./SummariesScreen.vue?vue&type=script&lang=js"
export * from "./SummariesScreen.vue?vue&type=script&lang=js"

import "./SummariesScreen.vue?vue&type=style&index=0&id=513a114d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513a114d"]])

export default __exports__